import { parseQueryString } from "../../backend/before";
import { createUISlider } from "../core/common";

const ShopItemPage = () => {
    const main = document.getElementById('shops-list');
    if (!main) {
        return;
    }

    const element = {
        productPriceFilter: document.getElementById('product-price-filter'),
        productBrandFilterClass: '.product-brand-filter',
        productSortKey: $('#product-sort-key'),
        productCountKey: $('#product-count-key'),
        btnProductFilterReset: $("#btn-reset-product"),
        viewedProducts: $("#viewed-products"),
    };

    const displayViewedProducts = () => {
        const products = JSON.parse(localStorage.getItem('vwdprd') || '[]');
        products.forEach((product) => {
            const url = `/shops/view/${product.slug}`;
            element.viewedProducts.append(`
                <div class="widget-products__item">
                    <div class="widget-products__image">
                        <a href="${url}"><img src="${product.picture}" alt="Picture"></a>
                    </div>
                    <div class="widget-products__info">
                        <div class="widget-products__name">
                            <a href="${url}">${product.name}</a>
                        </div>
                        <div class="widget-products__prices">
                            ${product.price}
                        </div>
                    </div>
                </div>
            `);
        })
    };

    createUISlider(element.productPriceFilter, function (values) {
        const queryParams = parseQueryString();

        queryParams['price'] = values.join('-');

        console.log('QueryString => ', queryParams);

        window.location = `${location.origin}${location.pathname}?${$.param(queryParams)}`;
    });

    displayViewedProducts();

    element.productSortKey.change(function() {
        const value = $(this).val();

        const queryParams = parseQueryString();

        queryParams['sort'] = value;

        window.location = `${location.origin}${location.pathname}?${$.param(queryParams)}`;
    });

    element.productCountKey.change(function() {
        const value = $(this).val();

        const queryParams = parseQueryString();

        queryParams['count'] = value;

        window.location = `${location.origin}${location.pathname}?${$.param(queryParams)}`;
    });

    element.btnProductFilterReset.click(function (e) {
        e.preventDefault();

        window.location = `${location.origin}${location.pathname}`;
    });

    $(element.productBrandFilterClass).change(function () {
        const selectors = $(`${element.productBrandFilterClass}:checked`);
        const values = [];
        const length = selectors.length;
        const queryParams = parseQueryString();

        for(let i = 0; i < length; i++) {
            values.push(selectors.eq(i).val());
        }

        queryParams['brands'] = values.join('-');

        window.location = `${location.origin}${location.pathname}?${$.param(queryParams)}`;
    });
};

$(() => {
    ShopItemPage();
});
